module.exports = __webpack_public_path__ + "static/media/1440x856-desktop.c5becae0.jpg";